import type { TButtonState } from 'src/components/0100_button';

export interface IButtonStateInput {
  isFetching?: boolean;
  isDirty?: boolean;
  isValid?: boolean;
  isSuccessful?: boolean; // terminal state
  isHighlight?: boolean;
  isWarning?: boolean;
}

export const buttonState = ({
  isFetching,
  isDirty,
  isValid,
  isSuccessful,
  isHighlight,
  isWarning,
}: IButtonStateInput): TButtonState => {
  if (isSuccessful) return 'success';
  if (isFetching) return 'loading';
  if (isDirty && isValid) {
    if (isHighlight) return 'enabled-highlight';
    if (isWarning) return 'enabled-warning';
    return 'enabled';
  }

  return 'disabled';
};
